import React, { useContext } from 'react';
import { WidthContext } from '../../WidthContext';
import './inlinePhotos.scss';

function InlinePhotos({ data }) {
  const { srcD, srcM } = data;
  const { viewSize } = useContext(WidthContext);
  return <img className="inline-photos" alt="" src={viewSize === 'large' ? srcD : srcM}></img>;
}

export default InlinePhotos;
